import { Enums } from "@flightscope/baseball-stats";
import GenericColorMapping from "./GenericColorMapping";
import colors from "./helpers/colors";

export default {
  [Enums.SwingDecision.Whiff.key]: colors.green.vidaLoca,
  [Enums.SwingDecision.Contact.key]: colors.red.thunderbird,
  [Enums.SwingDecision.Unclassified.key]: colors.grey.doveGray,
  ...GenericColorMapping
};
